export default __webpack_public_path__ + "static/media/1_0014.b07b202d.webp";